import type { NomIcone } from '../config/icons';

/**
 * Adaptations d'accessibilité de la maquette validée (CDC §9).
 *
 * Chaque option pose une classe sur `<body>`, et les styles correspondants
 * vivent dans `index.css`. Les valeurs — +18 %, +35 %, contraste 1,35 — sont
 * celles de la maquette : elles ne se changent pas sans validation client.
 */
export const OPTIONS_ACCESSIBILITE = [
  {
    cle: 'a11y-dys',
    icone: 'texte',
    libelle: 'Mode dyslexie',
    detail: 'Police sans empattement, espacement et interligne renforcés',
  },
  { cle: 'a11y-big', icone: 'zoom', libelle: 'Texte agrandi', detail: '+18 %' },
  { cle: 'a11y-big-xl', icone: 'zoomMax', libelle: 'Texte très grand', detail: '+35 %' },
  {
    cle: 'a11y-contrast',
    icone: 'contraste',
    libelle: 'Contraste renforcé',
    detail: 'Lisibilité + · textes et liens plus foncés',
  },
  { cle: 'a11y-yellow', icone: 'lune', libelle: 'Jaune sur noir', detail: 'Malvoyance' },
  {
    cle: 'a11y-ruler',
    icone: 'regle',
    libelle: 'Règle de lecture',
    detail: 'Une bande suit le pointeur',
  },
  {
    cle: 'a11y-focus',
    icone: 'cible',
    libelle: 'Mode focus',
    detail: 'Atténue ce qui n’est pas survolé · TDAH',
  },
  {
    cle: 'tts',
    icone: 'son',
    libelle: 'Lecture vocale',
    detail: 'Sélectionnez un texte pour l’entendre',
  },
] as const satisfies readonly {
  cle: string;
  icone: NomIcone;
  libelle: string;
  detail: string;
}[];

export type CleOption = (typeof OPTIONS_ACCESSIBILITE)[number]['cle'];

/**
 * Options qui s'excluent : deux tailles de texte ne peuvent pas s'appliquer
 * en même temps, la seconde annulerait la première de façon imprévisible.
 */
export const EXCLUSIONS: Partial<Record<CleOption, CleOption>> = {
  'a11y-big': 'a11y-big-xl',
  'a11y-big-xl': 'a11y-big',
};

export type EtatAccessibilite = Partial<Record<CleOption, boolean>>;
